export class NullTracker {
    track() { }
    page() { }
    identify() { }
    reset() { }
}
export function createAnalytics(writeKey, context) {
    if (!writeKey) {
        return new NullTracker();
    }
    // Segment integration wired in V2
    void context;
    return new NullTracker();
}
//# sourceMappingURL=index.js.map